export default {
  ru: {
    title: 'Селфи с роботом',
    description: 'Выберите хештег, который вам больше нравится, и я отображу его на экране,<br> чтобы вы могли сфотографироваться со мной',
    hashtag_1: '#Арктика',
    hashtag_2: '#НаСевереЖить',
    hashtag_3: '#КраеведческийМузей',
    hashtag_4: '#Мурманск',
  },
  en: {
    // en
  },
};
